enum Paths {
  BASE = '',
  LOGIN = BASE + '/login',
  AUTH_CALLBACK = BASE + '/auth/callback',
  KICK_OUT = BASE + '/kick-out',
  ERROR = BASE + '/error',
  MAIN = BASE + '/main',
  CALLS = MAIN + '/calls',
  MESSAGES = MAIN + '/messages',
  MESSAGES_CHATS = MESSAGES + '/chats',
  CONTACTS = MAIN + '/contacts',
  CONTACTS_GROUP_CHAT = CONTACTS + '/group-chat',
  FEEDS = MAIN + '/feeds',
  SHORTS = MAIN + '/shorts',
  WALLET = MAIN + '/wallet',
  DOCS = MAIN + '/docs',
  SETTINGS = MAIN + '/settings',
  SETTINGS_NOTIFICATIONS = SETTINGS + '/notifications',
  SETTINGS_GENERAL = SETTINGS + '/general',
  SETTINGS_SECURITY = SETTINGS + '/security',
  SETTINGS_PRIVACY = SETTINGS + '/privacy',
  SETTINGS_SYNC_BACKUP = SETTINGS + '/sync-backup',
  SETTINGS_DEVICES = SETTINGS + '/devices',
  SETTINGS_ABOUT = SETTINGS + '/about',
  SETTINGS_LANGUAGE = SETTINGS + '/language',

  NOT_FOUND = BASE + '*',
}

export default Paths;
